import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28c88022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-box xag-flex-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "联系客服", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "xag-flex-center",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onContactUs && _ctx.onContactUs(...args)))
    }, [
      _createVNode(_component_van_icon, {
        name: "/images/icon_kefu.svg",
        size: "18",
        style: {"margin-right":"4px"}
      }),
      _hoisted_2
    ])
  ]))
}